import React from "react";

/**
 * ReworkIcon — minimal single-path wrench (the universal repair symbol).
 *
 * One <path> element, ~200 bytes — the lightest practical SVG for the rework
 * badge. Uses currentColor so it inherits the teal rework theme.
 */
export default function ReworkIcon({ className = "", strokeWidth = 2, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 1 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9l-3.8 3.8z" />
    </svg>
  );
}
